const makeCheckbox = () => ({
  type: 'checkbox',
  checked: false,
  children: [{
    text: '',
  }],
});

export default makeCheckbox;
